import * as React from 'react'
import MUITab from '@mui/material/Tab'

const Tab = (props) => <MUITab {...props} />

export default Tab
